import * as Yup from 'yup';
import { DB_PREFIX } from './constants';

export default Yup.object().shape({
  [DB_PREFIX]: Yup.object().shape({
    dateTimeAvailable: Yup.object(),
    hourRate: Yup.object().shape({
      '0': Yup.number()
        .min(0)
        .integer(),
      '1': Yup.number()
        .min(0)
        .integer(),
    }),
    travelOptions: Yup.number()
      .min(0)
      .integer()
      .nullable()
      .required('Please select a value'),
  }),
});
